import Paddock from "../../assets/images/landmark/1.5/Paddock.svg";
import Structure from "../../assets/images/landmark/1.5/Structure.svg";
import Gate from "../../assets/images/landmark/1.5/Gate.svg";
import Corral from "../../assets/images/landmark/1.5/Corral.svg";
import Gateway from "../../assets/images/landmark/1.5/Gateway.svg";
import Trail from "../../assets/images/landmark/1.5/Trail.svg";
import Road from "../../assets/images/landmark/1.5/Road.svg";
import Pump from "../../assets/images/landmark/1.5/Pump.svg";
import Water from "../../assets/images/landmark/1.5/Water.svg";
import River from "../../assets/images/landmark/1.5/River.svg";
import Burn from "../../assets/images/landmark/1.5/Burn.svg";
import Feed from "../../assets/images/landmark/1.5/Feed.svg";
import Area from "../../assets/images/landmark/1.5/Area.svg";

import PaddockNormal from "../../assets/images/landmark/1.5/PaddockNormal.svg";
import StructureNormal from "../../assets/images/landmark/1.5/StructureNormal.svg";
import GateNormal from "../../assets/images/landmark/1.5/GateNormal.svg";
import CorralNormal from "../../assets/images/landmark/1.5/CorralNormal.svg";
import GatewayNormal from "../../assets/images/landmark/1.5/GatewayNormal.svg";
import TrailNormal from "../../assets/images/landmark/1.5/TrailNormal.svg";
import RoadNormal from "../../assets/images/landmark/1.5/RoadNormal.svg";
import PumpNormal from "../../assets/images/landmark/1.5/PumpNormal.svg";
import WaterNormal from "../../assets/images/landmark/1.5/WaterNormal.svg";
import RiverNormal from "../../assets/images/landmark/1.5/RiverNormal.svg";
import BurnNormal from "../../assets/images/landmark/1.5/BurnNormal.svg";
import FeedNormal from "../../assets/images/landmark/1.5/FeedNormal.svg";
import AreaNormal from "../../assets/images/landmark/1.5/AreaNormal.svg";

import PaddockHighlight from "../../assets/images/landmark/1.5/PaddockHighlight.svg";
import StructureHighlight from "../../assets/images/landmark/1.5/StructureHighlight.svg";
import GateHighlight from "../../assets/images/landmark/1.5/GateHighlight.svg";
import CorralHighlight from "../../assets/images/landmark/1.5/CorralHighlight.svg";
import GatewayHighlight from "../../assets/images/landmark/1.5/GatewayHighlight.svg";
import TrailHighlight from "../../assets/images/landmark/1.5/TrailHighlight.svg";
import RoadHighlight from "../../assets/images/landmark/1.5/RoadHighlight.svg";
import PumpHighlight from "../../assets/images/landmark/1.5/PumpHighlight.svg";
import WaterHighlight from "../../assets/images/landmark/1.5/WaterHighlight.svg";
import RiverHighlight from "../../assets/images/landmark/1.5/RiverHighlight.svg";
import BurnHighlight from "../../assets/images/landmark/1.5/BurnHighlight.svg";
import FeedHighlight from "../../assets/images/landmark/1.5/FeedHighlight.svg";
import AreaHighlight from "../../assets/images/landmark/1.5/AreaHighlight.svg";

const LandmarkIcons = {
  Area: Area,
  Burn: Burn,
  Corral: Corral,
  Feed: Feed,
  Fence: Paddock,
  Gate: Gate,
  Gateway: Gateway,
  Pump: Pump,
  River: River,
  Road: Road,
  Structure: Structure,
  Trail: Trail,
  Water: Water,
};

const LandmarkIconsNormal = {
  Area: AreaNormal,
  Burn: BurnNormal,
  Corral: CorralNormal,
  Feed: FeedNormal,
  Fence: PaddockNormal,
  Gate: GateNormal,
  Gateway: GatewayNormal,
  Pump: PumpNormal,
  River: RiverNormal,
  Road: RoadNormal,
  Structure: StructureNormal,
  Trail: TrailNormal,
  Water: WaterNormal,
};

const LandmarkIconsHighlight = {
  Area: AreaHighlight,
  Burn: BurnHighlight,
  Corral: CorralHighlight,
  Feed: FeedHighlight,
  Fence: PaddockHighlight,
  Gate: GateHighlight,
  Gateway: GatewayHighlight,
  Pump: PumpHighlight,
  River: RiverHighlight,
  Road: RoadHighlight,
  Structure: StructureHighlight,
  Trail: TrailHighlight,
  Water: WaterHighlight,
};

export { LandmarkIcons, LandmarkIconsNormal, LandmarkIconsHighlight };
